module.exports = __webpack_public_path__ + "static/img/deposit.6d38d4bb.png";